import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

// Date + time (IST, 12-hour, month name) — for call logs, interaction logs and notifications.
export const fmtDateTime = (s) =>
  s
    ? new Date(s).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      })
    : "—";

// Just the clock time (IST, 12-hour) — for compact "called at 3:42 PM" style labels.
export const fmtTime = (s) =>
  s
    ? new Date(s).toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      })
    : "";

// Phone helpers for tel: / wa.me deep links. Indian 10-digit numbers get a 91 country code.
export const telLink = (phone) => `tel:${String(phone || "").replace(/[^\d+]/g, "")}`;
export const waNumber = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (!d) return "";
  return d.length === 10 ? `91${d}` : d.replace(/^0+/, "");
};
export const waLink = (phone) => `https://wa.me/${waNumber(phone)}`;


// Fire after an interaction is logged so the notification bell clears in real-time.
export const pingNotifications = () =>
  window.dispatchEvent(new Event("notifications:refresh"));
